module.exports = __webpack_public_path__ + "img/GAME_GOSTOP2.19bdfc57.jpg";